import React, {
  useState,
} from 'react';

import {
  Popup,
} from 'web-components';

import * as S from './styled';

type Props = {
  place?: string,
  items?: any[],
  trigger?: React.ReactNode,
  itemSize?: number | string,
  minWidth?: number | string,
  preferPlace?: string,
  onChange?: { (item: any): void },
};

/**
 * Dropdown
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Dropdown = ({
  items,
  trigger,
  minWidth,
  itemSize,
  place,
  preferPlace,
  onChange,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popup
      place={place}
      isOpen={isOpen}
      trigger={trigger}
      preferPlace={preferPlace}
      setPopupVisible={(ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        setIsOpen(!isOpen);
      }}
      handleOuterAction={() => setIsOpen(false)}
    >
      <S.Dropdown minWidth={minWidth}>
        {items.map(item => (
          <div key={item.id || item.name}>
            <S.Item
              color={item.color}
              size={typeof itemSize === 'number' ? `${itemSize}px` : itemSize}
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (item.onClick) {
                  item.onClick();
                } else {
                  onChange(item);
                }
                setIsOpen(false);
              }}
            >
              {item.name}
            </S.Item>

            {item.divider && (
              <S.Divider />
            )}
          </div>
        ))}
      </S.Dropdown>
    </Popup>
  );
};

Dropdown.defaultProps = {
  place: undefined,
  preferPlace: 'below',
  items: [],
  itemSize: '13px',
  minWidth: '160px',
  trigger: null,
  onChange: () => {},
};

export default Dropdown;
